const compareObjects = (obj1, obj2) => {
  return JSON.stringify(sortObject(obj1)) === JSON.stringify(sortObject(obj2))
}

const isDate = (date) => {
  return date instanceof Date && !isNaN(date.valueOf())
}

const isObject = (value) => {
  return value && typeof value === 'object' && value.constructor === Object
}

const removeEmpty = (obj) => {
  return Object.fromEntries(Object.entries(obj).filter(([, v]) => !!v))
}

const sortObject = (object) => {
  if (!isObject(object)) return object
  const sortedObj = {}
  const keys = Object.keys(object)

  keys.sort((key1, key2) => {
    key1 = key1.toLowerCase()
    key2 = key2.toLowerCase()
    if (key1 < key2) return -1
    if (key1 > key2) return 1
    return 0
  })

  for (var index in keys) {
    var key = keys[index]
    if (typeof object[key] === 'object' && !(object[key] instanceof Array)) {
      sortedObj[key] = sortObject(object[key])
    } else {
      sortedObj[key] = object[key]
    }
  }

  return sortedObj
}

const getKeyCaseInsensitive = (object, key) => {
  if (!isObject(object)) return undefined
  key = `${key}`
  const asLowercase = key.toLowerCase()
  return object[
    Object.keys(object).filter(function (k) {
      return k.toLowerCase() === asLowercase
    })[0]
  ]
}

export {
  compareObjects,
  getKeyCaseInsensitive,
  isDate,
  isObject,
  removeEmpty,
  sortObject,
}
